import type {
  ApiParams,
  StoresData,
  StoresWhereSearch,
} from '~/types/commercetools';
import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';

export function useCtStoreApi() {
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const load = async (params: ApiParams<StoresWhereSearch>): Promise<StoresData | null> => {
    const storesData = await makeCommercetoolsRequest<StoresData>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_STORES,
      data: params,
    });

    return storesData?.data ?? null;
  };

  return {
    load,
  };
}
